function resolveTelegramWebApp(candidate) {
  if (candidate && typeof candidate === "object") {
    return candidate;
  }
  return window.Telegram?.WebApp ?? null;
}

export function getTelegramCloudStorage(candidate) {
  const webApp = resolveTelegramWebApp(candidate);
  if (!webApp) return null;

  for (const key of ["CloudStorage", "cloudStorage"]) {
    const storage = webApp[key];
    if (!storage || typeof storage !== "object") continue;

    const canRead = typeof storage.getItem === "function";
    const canWrite = typeof storage.setItem === "function";
    const canRemove = typeof storage.removeItem === "function" || canWrite;

    if (canRead || canWrite || canRemove) {
      return storage;
    }
  }

  return null;
}

export default getTelegramCloudStorage;
